import { Badge, Button, Col, Container, Modal, Row } from "react-bootstrap";
import ApiService from "../../../../services/api";
import "../css/album.css";
import { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import parse from "html-react-parser";
import Players from "./players";
import { AuthContext } from "../../../../services/auth";
import { Link } from "react-router-dom";

const Album = () => {
  const { isEnglish } = useContext(AuthContext);
  const [album, setAlbum] = useState({});
  const [albumDesciption, setAlbumDesciption] = useState({});
  const [category, setCategory] = useState({});
  const [filtredcategory, setFiltredcategory] = useState({});
  const [Loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [link, setLink] = useState("");
  const [music, setMusic] = useState({});
  const [musicTitle, setMusicTitle] = useState("");
  const [istrue, setIstrue] = useState(false);

  const fetchAlbumCategory = async () => {
    try {
      const AlbumList = await ApiService.getMusic();
      const AlbumDesciption = await ApiService.getAlbumDesciption();
      const Category = await ApiService.getCategories();
      setAlbum(AlbumList);
      setCategory(Category.filter((select) => select.type === "music"));
      setAlbumDesciption(AlbumDesciption);
      setFiltredcategory(AlbumList);
      setLoading(false);
    } catch (error) {
      setLoading(true);
    }
  };

  const filtredAlbum = (category) => {
    let filtred;
    filtred = album.filter((albums) => albums.category.name === category);
    // if (category === "COLONNE-SONORE") {
    //   filtred = album.filter((albums) => albums.category.name === category);
    // } else {
    //   filtred = album.filter((songs) => songs.category.name === category);
    // }
    setFiltredcategory(filtred);
  };
  useEffect(() => {
    fetchAlbumCategory();
  }, []);

  useEffect(() => {
    if (Array.isArray(album)) {
      filtredAlbum("COLONNE SONORE");
    }
  }, [album]);

  if (Loading) {
    return;
  }

  const buttonBlockChild = (data) => {
    setIstrue(data);
  };
  const CustomNextArrow = ({ onClick }) => (
    <div className="arrows right" onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
      </svg>
    </div>
  );

  const CustomPrevArrow = ({ onClick }) => (
    <div className="arrows left" onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
      </svg>
    </div>
  );

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const settings = {
    arrows: filtredcategory.length > 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    dots: false,
    infinite: filtredcategory.length > 1,
    speed: 1000,
    slidesToShow: filtredcategory.length > 5 ? 5 : filtredcategory.length,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow:
            filtredcategory.length > 1
              ? filtredcategory.length > 6
                ? 4
                : filtredcategory.length - 1
              : 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow:
            filtredcategory.length > 1
              ? filtredcategory.length > 6
                ? 3
                : filtredcategory.length - 2
              : 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Container fluid className=" p-0 text-center w-100 ">
      <Col className="bg-trasparent col-12 container-white_album d-flex justify-content-center align-items-center mt-3 pt-3">
        <Container className="w-100 pb-5 p-0">
          <h2 className="text-center section-title pt-5">
            {isEnglish ? "COMPOSITIONS" : "COMPOSIZIONI"}
          </h2>
          <div className="border-custom mt-3"></div>
          <Row className="w-100 m-0 px-2">
            {albumDesciption.map((description) => {
              return (
                <Col
                  className="col-12 d-flex justify-content-center align-items-center m-0 p-0 "
                  key={description.id}
                >
                  <Row className="contain-album-description m-0">
                    <Col className="col-12 my-2">
                      <h3 className="title_album">
                        {isEnglish ? description.title_eng : description.title}
                      </h3>
                    </Col>
                    <Col className="col-12 my-2 p-0">
                      <p className="section-text">
                        {isEnglish
                          ? parse(description.description_eng)
                          : parse(description.description)}
                      </p>
                    </Col>
                  </Row>
                </Col>
              );
            })}
          </Row>
        </Container>
      </Col>
      <Row className="m-0 w-100 pb-4 px-5 d-flex justify-content-center align-items-center">
        {category.map((category) => {
          return (
            <Col sm={"auto"} key={category.id} className="p-1 text-center">
              <Badge
                key={category.id}
                className="badge_container w-100 "
                bg="trasparent"
                pill
                onClick={() => {
                  filtredAlbum(category.name);
                }}
              >
                <div className="text_size_custom w-100">
                  {isEnglish ? category.name_eng : category.name}
                </div>
              </Badge>
            </Col>
          );
        })}
      </Row>
      <Col className=" col-12  text-center w-100 container-black_album ">
        <Container className="d-flex justify-content-center align-items-center container_slider px-5">
          <Slider {...settings} className=" w-100 p-0 m-0 ">
            {filtredcategory.map((categoryFiltred) => {
              return (
                <Col
                  key={categoryFiltred.id}
                  className="w-100 d-flex justify-content-center align-items-center container_slider m-0"
                >
                  <Row className="w-100 m-0">
                    <Col className="w-100 ">
                      {categoryFiltred.link && (
                        <a
                          href={categoryFiltred.link}
                          target="_blank"
                          rel="noreferrer"
                          className="d-flex justify-content-center align-items-center "
                        >
                          <img
                            src={categoryFiltred.img}
                            alt=""
                            className="img_custom_album object-fit-cover w-100 h-100 text-center"
                          ></img>
                        </a>
                      )}
                      {!categoryFiltred.link && (
                        <Row className="w-100 m-0">
                          <Link
                            to={
                              "/compositions/" +
                              categoryFiltred.category.name.toLowerCase() +
                              "/" +
                              categoryFiltred.slug
                            }
                          >
                            <Col className="col-12 w-100 d-flex justify-content-center align-items-center">
                              <img
                                src={categoryFiltred.img}
                                alt=""
                                className="img_custom_album object-fit-cover w-100  text-center"
                              ></img>
                            </Col>
                          </Link>
                          <div className="d-flex align-items-center justify-content-center">
                            <Row className="w-100  m-0 container-button-album">
                              {
                                <Col
                                  className={
                                    categoryFiltred.videos
                                      ? "pt-2 p-0 pe-1 text-center"
                                      : "pt-2 p-0 text-center"
                                  }
                                >
                                  <Button
                                    disabled={
                                      !categoryFiltred.music_tracks?.length > 0
                                    }
                                    id="button_open_player"
                                    className="margin-custom-album"
                                    variant="outline-dark text-white"
                                    onClick={() => {
                                      setMusicTitle(categoryFiltred.title);
                                      setIstrue(true);
                                      setLink("");
                                      setMusic(categoryFiltred.music_tracks);
                                    }}
                                  >
                                    {" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="25"
                                      height="25"
                                      fill="currentColor"
                                      className="bi bi-music-note"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2" />
                                      <path
                                        fillRule="evenodd"
                                        d="M9 3v10H8V3z"
                                      />
                                      <path d="M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5z" />
                                    </svg>
                                  </Button>
                                </Col>
                              }
                              {categoryFiltred.videos && (
                                <Col className="pt-2 p-0 ps-1 text-center">
                                  <Button
                                    id="button_open_video"
                                    className="margin-custom-album"
                                    variant="outline-dark text-white"
                                    onClick={() => {
                                      document.body.classList.remove(
                                        "visualized"
                                      );
                                      handleShow();
                                      setLink(categoryFiltred.videos);
                                    }}
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-play-btn" viewBox="0 0 16 16">
                                      <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"/>
                                      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"/>
                                    </svg>
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </div>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              );
            })}
          </Slider>
        </Container>
      </Col>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body className="container_modal d-flex justify-content-center align-items-center p-0 bg-black">
          <iframe
            title="video"
            src={link}
            className="w-100 container_modal p-0"
            allowFullScreen
          ></iframe>
        </Modal.Body>
      </Modal>
      {!link && istrue && (
        <Players
          music={music}
          musicTitle={musicTitle}
          buttonBlockChild={buttonBlockChild}
        />
      )}
    </Container>
  );
};
export default Album;
